import React from 'react';
import { View, Text, Modal, TouchableOpacity, StyleSheet, Image, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const SimpleRSKModal = ({ visible, onClose, rskAmount = 10 }) => {
  const { palette } = useTheme();

  if (!visible) return null;

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modal}>
          {/* Celebration header */}
          <View style={styles.headerBadge}>
            <Text style={styles.headerEmoji}>🎉</Text>
          </View>
          
          <Text style={styles.title}>Module Complete!</Text>
          <Text style={styles.subtitle}>Great work! Keep up the momentum!</Text>
          
          {/* Character Image - Larger */}
          <View style={styles.characterContainer}>
            <Image
              source={require('../assets/character_stills/FearIsFuel_CharacterStills_Tommy_HandsInAir_v01_SL.png')}
              style={styles.character}
              resizeMode="contain"
            />
          </View>
          
          {/* RSK Badge */}
          <View style={styles.rskBadge}>
            <Text style={styles.rskLabel}>You earned</Text>
            <View style={styles.rskAmountContainer}>
              <Text style={styles.rskAmount}>+{rskAmount}</Text>
              <Text style={styles.rskCurrency}>RSK</Text>
            </View>
          </View>
          
          {/* Continue Button */}
          <TouchableOpacity 
            style={styles.button}
            onPress={onClose}
            activeOpacity={0.8}
          >
            <Text style={styles.buttonText}>Continue</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modal: {
    width: '100%',
    maxWidth: 420,
    backgroundColor: '#FFFFFF',
    borderRadius: 24,
    borderWidth: 4,
    borderColor: '#000000',
    padding: 32,
    alignItems: 'center',
    ...Platform.select({
      web: {
        boxShadow: '8px 10px 0px #000000',
      },
    }),
  },
  headerBadge: {
    width: 70,
    height: 70,
    borderRadius: 35,
    backgroundColor: '#F7DF7B',
    borderWidth: 3,
    borderColor: '#000000',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    ...Platform.select({
      web: {
        boxShadow: '3px 3px 0px #000000',
      },
    }),
  },
  headerEmoji: {
    fontSize: 32,
  },
  title: {
    fontSize: 28,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: '800',
    color: '#000000',
    marginBottom: 8,
    textAlign: 'center',
    ...Platform.select({
      web: {
        textShadow: '2px 2px 0px rgba(0,0,0,0.1)',
      },
    }),
  },
  subtitle: {
    fontSize: 15,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: '500',
    color: '#666666',
    marginBottom: 20,
    textAlign: 'center',
  },
  characterContainer: {
    width: 200,
    height: 220,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  character: {
    width: 200,
    height: 220,
  },
  rskBadge: {
    backgroundColor: '#22C55E',
    borderRadius: 16,
    borderWidth: 3,
    borderColor: '#000000',
    paddingHorizontal: 28,
    paddingVertical: 14,
    marginBottom: 24,
    alignItems: 'center',
    ...Platform.select({
      web: {
        boxShadow: '4px 4px 0px #000000',
      },
    }),
  },
  rskLabel: {
    fontSize: 12,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: '600',
    color: 'rgba(255,255,255,0.85)',
    textTransform: 'uppercase',
    letterSpacing: 1,
    marginBottom: 4,
  },
  rskAmountContainer: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 6,
  },
  rskAmount: {
    fontSize: 32,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: '800',
    color: '#FFFFFF',
  },
  rskCurrency: {
    fontSize: 18,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: '700',
    color: 'rgba(255,255,255,0.9)',
  },
  button: {
    backgroundColor: '#FF4747',
    paddingHorizontal: 48,
    paddingVertical: 16,
    borderRadius: 14,
    borderWidth: 3,
    borderColor: '#000000',
    ...Platform.select({
      web: {
        cursor: 'pointer',
        boxShadow: '4px 4px 0px #000000',
        transition: 'transform 0.1s, box-shadow 0.1s',
      },
    }),
  },
  buttonText: {
    fontSize: 18,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: '700',
    color: '#FFFFFF',
  },
});

export default SimpleRSKModal;
